import type { Middleware, MiddlewareAPI, UnknownAction } from '@reduxjs/toolkit';
import { isRejectedWithValue } from '@reduxjs/toolkit';
import { handlSetIsDeployig } from 'redux-store/slices/auth-slice';
import { getEnvironmentConfig } from 'utils/environment';

const { apiUrl } = getEnvironmentConfig();

export enum FetchStatus {
  FETCH_ERROR = 'FETCH_ERROR',
}

interface FetchErrorPayload {
  status?: string;
  [key: string]: any;
}

interface BaseQueryMeta {
  request?: { url?: string };
  [key: string]: any;
}

interface MetaWithUrl {
  baseQueryMeta?: BaseQueryMeta;
  [key: string]: any;
}

export const rtkErrorHandler: Middleware =
  ({ dispatch }: MiddlewareAPI) =>
  (next) =>
  (action: UnknownAction) => {
    if (isRejectedWithValue(action)) {
      const payload = action?.payload as FetchErrorPayload | undefined;
      const meta = action?.meta as MetaWithUrl | undefined;
      const url = meta?.baseQueryMeta?.request?.url;

      if (payload?.status === FetchStatus.FETCH_ERROR && url?.startsWith(apiUrl)) {
        dispatch(handlSetIsDeployig());
      }
    }

    return next(action);
  };
